import { supabase } from './supabaseClient';

function getFrontendBaseUrl(): string {
	const envUrl = (import.meta as any).env?.VITE_PUBLIC_APP_URL;
	if (typeof envUrl === 'string' && envUrl.trim().length > 0) return envUrl.trim();
	return window.location.origin;
}

export async function performLogoutRedirect() {
	try {
		await supabase.auth.signOut();
	} catch {}
	try {
		// Best-effort cleanup of auth and cross-user bleed keys
		const authRaw = localStorage.getItem('auth_user');
		let userId: string | null = null;
		try { userId = authRaw ? JSON.parse(authRaw)?.id || null : null; } catch {}
		localStorage.removeItem('auth_user');
		localStorage.removeItem('auth_token');
		localStorage.removeItem('quick_call_draft_v1'); // legacy
		if (userId) {
			localStorage.removeItem(`quick_call_draft_v1:${userId}`);
		}
		// Inbound drafts (prevent bleed)
		for (let i = 0; i < localStorage.length; i++) {
			const k = localStorage.key(i);
			if (!k) continue;
			if (k.startsWith('inbound-draft:') || k.startsWith('inbound-archived:') || k.startsWith('inbound-snapshots:')) {
				try { localStorage.removeItem(k); } catch {}
			}
		}
		// Calendar UI cache is user-specific
		localStorage.removeItem('calendar-storage');
	} catch {}
	const base = getFrontendBaseUrl();
	window.location.assign(`${base}/login`);
}
